import { Card, CardContent } from './chunk-SWFXEBPS.js';
import { cn } from './chunk-FFX3LZW7.js';
import { ArrowUp, ArrowDown, ArrowRight } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

function KpiCard({
  label,
  value,
  delta,
  positiveIsGood = true,
  helperText,
  className
}) {
  const direction = delta?.value === void 0 ? "flat" : delta.value > 0 ? "up" : delta.value < 0 ? "down" : "flat";
  const isGood = direction === "flat" ? null : direction === "up" ? positiveIsGood : !positiveIsGood;
  return /* @__PURE__ */ jsx(Card, { className: cn("flex flex-col gap-2 p-4", className), children: /* @__PURE__ */ jsxs(CardContent, { className: "flex flex-col gap-1 p-0", children: [
    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium uppercase tracking-wide text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx("span", { className: "text-2xl font-semibold", children: value }),
    delta && /* @__PURE__ */ jsxs(
      "span",
      {
        className: cn(
          "inline-flex items-center gap-1 text-sm",
          isGood === null && "text-muted-foreground",
          isGood === true && "text-risk-none",
          isGood === false && "text-risk-critical"
        ),
        children: [
          direction === "up" && /* @__PURE__ */ jsx(ArrowUp, { className: "size-3" }),
          direction === "down" && /* @__PURE__ */ jsx(ArrowDown, { className: "size-3" }),
          direction === "flat" && /* @__PURE__ */ jsx(ArrowRight, { className: "size-3" }),
          /* @__PURE__ */ jsxs("span", { children: [
            Math.abs(delta.value).toFixed(1),
            "% \xB7 ",
            delta.period
          ] })
        ]
      }
    ),
    helperText && /* @__PURE__ */ jsx("span", { className: "mt-1 text-xs text-muted-foreground", children: helperText })
  ] }) });
}

export { KpiCard };
//# sourceMappingURL=chunk-HELA2CO4.js.map
//# sourceMappingURL=chunk-HELA2CO4.js.map